export const codeMessage = {
  200: "success",
  201: "created",
  4001: "Email Already Exist!",
  4002: "Transaction Failed Payment Unsuccessful",
  4003: "Contact Number Already Exist!",
  4004: "Error fetching data from sap",
  4005: "Failed to reserve",
  4006: "Agent's ID Invalid",
  4007: "Reservation no is Invalid",
  4008: "You already paid your reservation fee",
  4009: "Reservation number and agent ID is not match"
};
